<template>
    <div class="add-blog">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="add_item" title="Agregar item">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <div>
                    <button @click="changeItem('texto')" :class="{'active': isItem === 'texto'}">Agregar texto</button>
                    <button @click="changeItem('imagen')" :class="{'active': isItem === 'imagen'}">Agregar Imagen</button>
                    <button @click="changeItem('video')" :class="{'active': isItem === 'video'}">Video youtube</button>
                </div>
                <div v-if="isItem === 'texto'" class="texto">
                    <label for="">Agregar texto</label>
                    <textarea v-model="texto" id="" cols="60" rows="10"></textarea>
                </div>
                <div v-if="isItem === 'imagen'" class="texto">
                    <label for="" v-if="!imgSelected">Agregar imagen</label>
                    <input type="file" style="display: none" ref="select_file_product" name="photo" @change="imgSelected = !imgSelected" class="register-file" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp" />
                    <button v-if="!imgSelected" @click="$refs.select_file_product.click()">Cargar imagen</button>
                    <center v-if="imgSelected">
                        <button @click="imgSelected = !imgSelected">Cambiar</button>
                        <h5>Se ha seleccionado la imagen</h5>
                    </center>
                </div>
                <div v-if="isItem === 'video'" class="texto">
                    <label for="">Agregar Enlace de video</label>
                    <input v-model="video" type="text">
                </div>
                <button @click="addItem">Agregar item</button>
            </div>
        </b-modal>
        <button @click="change">Articulos publicados</button>
        <div class="register" v-if="isRegister && !isEdit">
            <div>
                <h1>Agregar Blog</h1>
                <p v-if="isError && itemError">Asegurate que todos los campos esten completos</p>
                <div>
                    <label for="">Agregar titulo</label>
                    <input type="text" v-model="titulo">
                </div>
                <div>
                    <label for="">Agregar subtitulo</label>
                    <input type="text" v-model="subtitulo">
                </div>
                <div>
                    <label for="">Nombre escritor</label>
                    <input type="text" v-model="escritor">
                </div>
                <div>
                    <label for="">Imagen escritor</label>
                    <input type="file" ref="select_file_escritor" name="imagen" id="" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp"/>
                </div>
                <div>
                    <label for="">Agregar portada</label>
                    <input type="file" ref="select_file_portada" name="imagen" id="" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp">
                </div>
                <div>
                    <label for="">Link llamado acción</label>
                    <input type="text" v-model="link">
                </div>
                <div>
                    <label for="">Web</label>
                    <select name="" id="" v-model="web">
                        <option value="1">Inserseguros</option>
                        <option value="2">Aserseguridad</option>
                    </select>
                </div>
                <center><button @click="createArticulo()">Agregar Articulo</button></center>
            </div>
        </div>
        <div class="list" v-if="isRegister && !isEdit">
            <div>
                <button @click="$refs.add_item.show()">Agregar</button>
                <h1>Agregar Item</h1>
                <div>
                    <div v-for="(item, index) in items" :key="index">
                        <div v-if="item.type === 'texto'">
                            <p v-html="item.info"></p>
                            <h3 @click="deleteItem(index)">X</h3>
                        </div>
                        <div v-if="item.type === 'imagen'">
                            <img :src="item.imagen" alt="">
                            <h3 @click="deleteItem(index)">X</h3>
                        </div>
                        <div v-if="item.type === 'video'">
                            <label for="">{{item.info}}</label>
                            <h3 @click="deleteItem(index)">X</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="articule-list" v-if="!isRegister && !isEdit">
            <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200">
                <div v-for="(item, index) in articules" :key="index">
                    <div class="image"><img :src="item.portada" alt=""></div>
                    <div class="infos">
                        <div><h5 @click="deleteArticulo(item.id)">X</h5></div>
                        <span>{{ item.subtitulo }}</span>
                        <h3>{{ item.titulo }}</h3>
                        <p>{{ item.info.substring(0,100) + '...' }}</p>
                        <div>{{ item.nombre }}</div>
                        <div v-if="item.web === '1'">Interseguros</div>
                        <div v-if="item.web === '2'">Aserseguridad</div>
                        <toggle-button
                            v-model="item.status"
                            class="toggle"
                            color="#82C7EB"
                            :sync="true"
                            :width="100"
                            :height="40"
                            :labels="{checked: 'ON', unchecked: 'OFF'}"
                            @change="changeStatus(item.id)"/>
                        <button @click="editar(item)">Editar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="register" v-if="!isRegister && isEdit">
            <div>
                <h1>Editar Blog</h1>
                <p v-if="isError && itemError">Asegurate que todos los campos esten completos</p>
                <div>
                    <label for="">Agregar titulo</label>
                    <input type="text" v-model="titulo">
                </div>
                <div>
                    <label for="">Agregar subtitulo</label>
                    <input type="text" v-model="subtitulo">
                </div>
                <div>
                    <label for="">Nombre escritor</label>
                    <input type="text" v-model="escritor">
                </div>
                <div>
                    <label for="">Imagen escritor</label>
                    <input type="file" ref="select_file_escritor_update" name="imagen" id="" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp"/>
                </div>
                <div>
                    <label for="">Agregar portada</label>
                    <input type="file" ref="select_file_portada_update" name="imagen" id="" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp">
                </div>
                <div>
                    <label for="">Link llamado acción</label>
                    <input type="text" v-model="link">
                </div>
                <div>
                    <label for="">Web</label>
                    <select name="" id="" v-model="web">
                        <option value="1">Interseguros</option>
                        <option value="2">Aserseguridad</option>
                    </select>
                </div>
                <center><button @click="updateBlog()">Editar Articulo</button></center>
            </div>
        </div>
        <div class="list" v-if="!isRegister && isEdit">
            <div>
                <button @click="$refs.add_item.show()">Agregar</button>
                <h1>Agregar Item</h1>
                <div>
                    <div v-for="(item, index) in items" :key="index">
                        <div v-if="item.name === 'texto' || item.type === 'texto'">
                            <p v-html="item.info"></p>
                            <h3 @click="deleteItemFromAPI(item.id)">X</h3>
                        </div>
                        <div v-if="item.name === 'imagen' || item.type === 'imagen'">
                            <img v-if="item.info" :src="item.info" alt="">
                            <img v-if="item.imagen" :src="item.imagen" alt="">
                            <h3 @click="deleteItemFromAPI(item.id)">X</h3>
                        </div>
                        <div v-if="item.name === 'video'  || item.type === 'video'">
                            <label for="">{{item.info}}</label>
                            <h3 @click="deleteItemFromAPI(item.id)">X</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Notify from '@/utils/Notification'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
    name: 'add-blog',
    components: {
        ToggleButton
    },
    data() {
        return {
            isEdit: false,
            isRegister: true,
            items: [],
            isItem: 'texto',
            texto: null,
            video: null,
            imgSelected: false,
            productsPicture: null,
            productsPictureObject: null,
            titulo: null,
            subtitulo: null,
            escritor: null,
            link: null,
            web: 1,
            isError: false,
            itemError: false,
            articules: [],
            limit: 20,
            offset: 0,
            blogId: null,
            cantItems: 0
        }
    },
    methods: {
        changeStatus(id) {
            API.changeStatus(id)
                .then((res) => {
                    this.getArticulesList()
                })
        },
        change() {
            if (this.isEdit) {
                this.isEdit = !this.isEdit
                this.isRegister = true
                this.items = []
                this.cantItems = 0
                this.titulo = null
                this.subtitulo = null
                this.escritor = null
                this.img = null
                this.link = null
                this.portada = null
                this.web = 1
            }
            this.isRegister = !this.isRegister
        },
        deleteItemFromAPI(id) {
            API.deleteItemFromAPI(id, this.blogId)
                .then((res) => {
                    this.items = res
                })
        },
        editar(blog) {
            this.blogId = blog.id
            API.getItems(blog.id)
                .then((res) => {
                    this.items = res
                    this.cantItems = res.length
                    this.titulo = blog.titulo
                    this.subtitulo = blog.subtitulo
                    this.escritor = blog.nombre
                    this.img = blog.img
                    this.link = blog.link
                    this.portada = blog.portada
                    this.web = parseInt(blog.web)
                    this.isEdit = true
                    this.isRegister = false
                })
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.articules.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getArticulesList()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        deleteArticulo(id) {
            API.deleteArticulo(id)
                .then(() => {
                    this.articules = []
                    this.offset = 0
                    this.getArticulesList()
                })
        },
        getArticulesList() {
            API.getArticulesList(this.limit, this.offset, 'todo')
                .then((res) => {
                    res.map(item => { this.articules.push(item) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        },
        createArticulo() {
            if (this.items.length === 0) {
                return
            }
            if (this.titulo === null) {
                return
            }
            if (this.subtitulo === null) {
                return
            }
            if (this.escritor === null) {
                return
            }
            if (this.web === null) {
                return
            }
            if (this.link === null) {
                return
            }
            var file = this.$refs.select_file_portada.files
            if (!file.length) {
                return
            }

            this.saveImage(file[0], () => {
                var file = this.$refs.select_file_escritor.files
                if (!file.length) {
                    return
                }
                var portada = this.productsPictureObject
                this.saveImage(file[0], () => {
                    var imgEscritor = this.productsPictureObject
                    API.createArticulo(this.titulo, this.subtitulo, this.escritor, this.web, portada, imgEscritor, this.link, this.items)
                        .then((res) => {
                            this.items = []
                            this.texto = null
                            this.video = null
                            this.imgSelected = false
                            this.productsPicture = null
                            this.productsPictureObject = null
                            this.titulo = null
                            this.link = null
                            this.subtitulo = null
                            this.escritor = null
                            this.getArticulesList()
                            Notify(res.status === 1 ? 'dirty' : 'error', res.msg)
                        })
                })
            })
        },
        updateBlog() {
            if (this.items.length === 0) {
                return
            }
            if (this.titulo === null) {
                return
            }
            if (this.subtitulo === null) {
                return
            }
            if (this.web === null) {
                return
            }
            if (this.link === null) {
                return
            }
            var file = []
            file = this.$refs.select_file_portada_update.files
            if (file.length === 0) {
                file = []
                file[0] = null
            }
            this.saveImage(file[0], (respo) => {
                var file = []
                file = this.$refs.select_file_escritor_update.files
                if (file.length === 0) {
                    file = []
                    file[0] = null
                }
                var portada = null
                if (respo !== null) {
                    portada = this.productsPictureObject
                }
                this.productsPictureObject = null
                this.saveImage(file[0], (respoEsc) => {
                    var imgEscritor = null
                    if (respoEsc !== null) {
                        imgEscritor = this.productsPictureObject
                    }
                    var newItems = this.items
                    newItems.splice(0, this.cantItems)
                    API.updateBlog(this.titulo, this.subtitulo, this.escritor, this.web, portada, imgEscritor, this.link, newItems, this.blogId)
                        .then((res) => {
                            this.items = []
                            this.texto = null
                            this.video = null
                            this.imgSelected = false
                            this.productsPicture = null
                            this.productsPictureObject = null
                            this.titulo = null
                            this.subtitulo = null
                            this.escritor = null
                            this.isEdit = false
                            this.offset = 0
                            this.articules = []
                            this.getArticulesList()
                            Notify(res.status === 1 ? 'dirty' : 'error', res.msg)
                        })
                })
            })
        },
        deleteItem(index) {
            this.items.splice(index, 1)
            this.cantItems -= 1
        },
        changeItem(item) {
            this.isItem = item
        },
        async addItem() {
            var info = {}
            info.type = this.isItem
            if (this.isItem === 'imagen') {
                var file = this.$refs.select_file_product.files
                if (!file.length) {
                    return
                }
                this.saveImage(file[0], () => {
                    info.info = this.productsPictureObject
                    info.imagen = this.productsPicture
                    this.items.push(info)
                })
            } else if (this.isItem === 'video') {
                info.info = this.video
                this.items.push(info)
            } else {
                info.info = this.texto
                this.items.push(info)
            }
            this.$refs.add_item.hide()
            this.video = null
            this.texto = null
            this.$refs.select_file_product = null
        },
        saveImage (file, cb) {
            if (file === null) {
                cb(null)
                return
            }
            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
                vm.productsPicture = e.target.result
                vm.productsPictureObject = file
                if (cb) {
                    var toSend = {}
                    toSend.src = vm.productsPicture
                    cb(toSend)
                }
            }
            reader.readAsDataURL(file)
        }
    },
    mounted() {
        this.getArticulesList()
    }
}
</script>

<style scoped>
 .add-blog {
    background-image: url('../assets/servicios-bg-empresariales.png');
    height: 100vh;
    width: 100%;
    display: flex;
 }
 .add-blog > button{
    background-color:#65b24a;
    position: fixed;
    color: #fff;
    width: 200px;
    font-family: 'JBD';
    font-size: 18px;
    border-style: solid;
    padding: 10px;
    border-radius: 20px;
    margin-top: 30px;
    left: 50%;
    transform: translateX(-50%);
 }
 .add-blog > div.register, .add-blog > div.list{
    width: 50%;
    text-align: center;
    padding: 40px;
    padding-top: 100px;
    color: #65b24a;
    font-family: 'JBD';
 }
 .add-blog > div.register > div{
    padding: 20px;
    width: 100%;
    background: #fff;
    color: #000;
    border-radius: 60px;
    color: #65b24a;
    height: 100%;
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
 }
 .add-blog > div.register > div::-webkit-scrollbar {
    display: none;
 }
 .add-blog > div.register > div > p {
    color: red;
 }
 .add-blog > div.register > div > center > button {
    background-color: #65b24a;
    color: #fff;
    width: 200px;
    font-family: 'JBD';
    font-size: 18px;
    border-style: solid;
    padding: 10px;
    border-radius: 20px;
    margin-top: 30px;
 }
 .add-blog > div.register > div > div{
    display: grid;
    margin: 20px;
 }
 .add-blog > div.register > div > div > label{
    font-family: 'JBD';
    color: #65b24a;
 }
 .add-blog > div.register > div > div > input, select{
    height: 40px;
    border-radius: 20px;
    border-style: groove;
    text-align: center;
 }

 .add-blog > div.list > div{
    padding: 20px;
    width: 100%;
    background: #fff;
    color: #000;
    border-radius: 60px;
    color: #2d4f98;
    height: 100%;
    position: relative;
 }
 .add-blog > div.list > div >button{
    padding: 20px;
    background: #65b24a;
    color: #000;
    border-radius: 60px;
    color: #fff;
    position: absolute;
    right: 30px;
 }

 .add-blog > div.list > div > div{
    text-align: justify;
    padding: 50px;
    width: 100%;
    overflow-y: auto;
    height: 80%;
    overflow-x: hidden;
 }
 .add-blog > div.list > div > div > div{
    width: 100%;
    background-color: #2d4f98;
    color: #fff;
    padding: 10px;
    position: relative;
    margin: 10px;
    border-radius: 20px;
 }

 .add-blog > div.list > div > div > div > div >  h3{
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
 }

 .add-blog > div.list > div > div > div > div >  p{
    white-space: pre;
    width: 80%;
 }

 .add-blog > div.list > div > div > div > div >  img{
    width: 80%;
 }

 .info-wrapper > div > button {
    padding: 20px;
    background: #2d4f98;
    color: #000;
    border-radius: 60px;
    color: #fff;
 }
 .info-wrapper > div > button.active {
    background: #65b24a;
 }

 .info-wrapper > div.texto{
    display: grid;
    padding: 30px;
 }
 .info-wrapper > div > label {
    color: #65b24a;
    font-family: 'JBD';
    font-size: 16px;

 }
 .info-wrapper > div.texto > textarea{
    border-radius: 20px;
 }
 .info-wrapper > div > input{
    border-radius: 20px;
    height: 40px;
    width: 400px;
    text-align: center;
 }
 .info-wrapper > div > center > button {
    padding: 20px;
    background: #65b24a;
    color: #000;
    border-radius: 60px;
    color: #fff;
 }
 .info-wrapper > div > center > h5 {
    color: #2d4f98;
 }

 .info-wrapper > button {
    padding: 20px;
    background: #65b24a;
    color: #000;
    border-radius: 60px;
    color: #fff;
 }

 .articule-list {
    padding: 20px 100px;
    width: 100%;
    background-image: url('../assets/servicios-bg-empresariales.png');
    background-attachment: fixed;
}
.articule-list > div {
    width: 100%;
    margin-top: 100px;
}
.articule-list > div > div{
    width: 50%;
    display: inline-flex;
}

.articule-list > div > div > div.image {
    padding: 20px;
    display: inline-block;
    z-index: 1;
}

.articule-list > div > div > div.image > img{
    object-fit: cover;
    width: 300px;
    height: 350px;
}

.articule-list > div > div > div.infos {
    background-color: #fff;
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    width: 100%;
    height: 300px;
    padding: 10;
    padding-top: 20px;
    margin-top: 80px;
    margin-left: -100px;
    z-index: 0;
    padding-left: 100px;
    text-align: justify;
    font-family: 'JR';
    position: relative;
}
.articule-list > div > div > div.infos > div{
    padding: 20px;
    float: right;
    color: #2d4f98;
    font-weight: bold;
    font-style: oblique;
}

.articule-list > div > div > div.infos > div > h5{
    font-weight: bolder;
}

.articule-list > div > div > div.infos > div > h5:hover {
    color: red;
    cursor: pointer;
}
.articule-list > div > div > div.infos > span{
    margin-top: 1000px;
    color: #000;
    font-weight: bold;
}
.articule-list > div > div > div.infos > h3{
    margin-top: 20px;
    color: #2d4f98;
    text-align: left;
    font-family: 'JBD';
}
.articule-list > div > div > div.infos > p{
    color: #000;
    text-align: left;
}
.articule-list > div > div > div.infos > button{
    position: absolute;
    background-color: #65b24a;
    width: 150px;
    height: 40px;
    text-align: center;
    border-radius: 20px;
    padding: 5px;
    border-color: #65b24a;
    border-style: solid;
    font-size: 20px;
    color: #fff;
    margin-top: 20px;
    bottom: 40px;
    cursor: pointer;
}

.articule-list > div > div > div > button:hover {
    color: #65b24a;
    background-color: #fff;
    cursor: pointer;
}

@media (max-width: 1500px) {
    .title {
        padding: 200px 200px;
    }
    .info > h1 {
        padding-left: 200px;
    }
}

@media (max-width: 1400px) {
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    .title {
        padding: 200px 100px;
    }
    .info > h1 {
        padding-left: 100px;
    }
}

@media (max-width: 1300px) {
    .info > h1 {
        font-size: 30px;
    }
    .articule-list {
        padding: 20px 100px;
        width: 100%;
        display: inline-flex;
    }
    .articule-list > div > div{
        width: 50%;
        align-items: center;
        justify-items: center;
        display: inline-block;
    }
    .articule-list > div > div > div.image {
        padding: 20px;
        display: grid;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div > div.infos {
        margin-top: -30px;
        width: 100%;
        margin-left: 0px;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div > div.infos > button{
        left: 50px;
    }
    .articule-list > div > div > div.infos > div{
        margin-top: 50px;
    }
}

@media (max-width: 1100px) {
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    #contactForm {
        margin-top: -100px;
        right: 50px;
    }
}

@media (max-width: 1000px) {
    .title {
        padding: 50px 0px;
        height: 400px;
        text-align: center;
    }
    #contactForm {
        margin-top: 10px;
        left: 0;
        right: 0;
        margin: auto;
    }
    .info {
        padding-top: 400px;
        width: 100%;
        text-align: center;
    }
    .info > h1 {
        padding: 10px;
        width: 100%;
        text-align: center;
    }
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    .articule-list > div {
        display: grid;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div{
        display: flex;
        width: 80%;
    }
    .articule-list > div > div > div.infos {
        margin-left: -100px;
    }
    .articule-list > div > div > div.infos > button{
        left: 100px;
    }
}

@media (max-width: 800px) {
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    .articule-list > div {
        display: grid;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div{
        display: flex;
        width: 100%;
    }
    .articule-list > div > div > div.infos > button{
        left: 100px;
    }
}

@media (max-width: 750px) {
    .articule-list {
        padding: 20px 20px;
        width: 100%;
    }
    .articule-list > div {
        display: grid;
        align-items: center;
        justify-items: center;
    }
    .articule-list > div > div{
        display: grid;
        width: 100%;
    }
    .articule-list > div > div > div.infos > button{
        left: 100px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/addBlog.vue